import { stringToBoolean } from 'utils/helpers/string-to-boolean';

import { nursingInterventionOptions } from './templates/common';

import type { FormikProps } from 'formik';

export const checkSymptomsUpdate = (
  requiredSymptomFields: string[],
  formik: FormikProps<any>,
  toggleModalCallback: () => void,
) => {
  const selectedRequiredFields = Object.entries(formik.values)
    .filter(([key, _]) => requiredSymptomFields.includes(key))
    .reduce<Record<string, any>>((acc, [key, value]) => {
      const booleanValue =
        typeof value === 'string' ? stringToBoolean(value as string) : value;
      if (booleanValue !== null) acc[key] = booleanValue;
      return acc;
    }, {});

  if (
    requiredSymptomFields.length === Object.keys(selectedRequiredFields).length
  ) {
    const hasTrueValue = Object.values(selectedRequiredFields).some(
      (value) => value === true,
    );

    if (hasTrueValue) {
      toggleModalCallback();
      formik.setFieldValue('checkSymptoms', false);
    }
  }
};

export const removeTextInParentheses = (str: string) => {
  return str.replace(/\([^)]*\)/g, '').trim();
};

export const prepareFactors = (arr: string[]) =>
  arr.map(removeTextInParentheses);

export const scrollToErrorElement = (wrapper: HTMLDivElement | null) => {
  const elementWithError = wrapper?.querySelector('[class*="error"]');
  if (!elementWithError) return;

  elementWithError.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
  });
};

export const getNursingInterventionValues = (
  selectedData?: string[] | null,
) => {
  const emergencyRoom = selectedData?.includes(
    nursingInterventionOptions[0].label,
  );
  const escalation = selectedData?.includes(
    nursingInterventionOptions[1].label,
  );
  const nursingEducation = selectedData?.includes(
    nursingInterventionOptions[2].label,
  );

  return {
    emergencyRoom,
    escalation,
    nursingEducation,
  };
};
